
import React from 'react';
import { connect } from "react-redux"
import { DashboardContainer } from "../../funcs/utils";
import {sprintf} from "sprintf-js";
import {DEVICE, SUPER_ADMIN, USER, WLF_ADMIN} from "../../../lib/constants";
import {dollarToString} from "../../../lib/currency-utils";
import {Link} from "react-router-dom";
import {DashboardTable} from "../dashboard-table";
import {objToUrlParam} from "../../../lib/url-util";


const BARS_SVG = require("./bar_chart.svg");

const priceFontSize = "1.6rem";

const renderHeader = (text, override) => {
  const spanStyle = {
    fontWeight: "bold",
    fontSize: "1.4rem",
    ...override,
  };

  return (<span style={spanStyle}>{ text }</span>);
};

const renderPrice = (cents, rightPadding, style_override = {}) => {
  const spanStyle = {
    fontSize: priceFontSize,
    paddingRight: rightPadding,
    ...style_override,
  };
  if (cents < 0) {
    spanStyle.color = "#F00";
  }

  if (typeof cents === "number") {
    return (<span style={spanStyle}>{dollarToString(cents)}</span>);
  } else if (typeof cents === "string") {
    return (<span style={spanStyle}>{cents}</span>);
  }
};

const renderPrice_2 = cents => {
  let color = "#000";
  if (cents > 0) {
    color = "#008040";
  } else if (cents < 0) {
    color = "#F00";
  }
  const style = {
    color
  };
  return (<span style={style}>{dollarToString(cents)}</span>);
};

const renderPercent = pct => {
  pct *= 100;
  pct = Math.floor(pct * 1e4) / 1e4;
  const spanStyle = {
    //fontSize: priceFontSize,
  };
  if (pct < 0) {
    spanStyle.color = "#F00";
  }
  return (
    <span style={spanStyle}>
        { sprintf("%.4f %%", pct) }
      </span>);
};

const renderAccountTable = (component, user, do_small) => {
  const acct_type = user.account_type;
  const is_admin = acct_type === SUPER_ADMIN || acct_type === WLF_ADMIN;

  const headers = ["Account", "Total Value", "Securities", "Cash", "Change", ""];
  const colAlign = ["left", "left", "left", "left", "left", "left"];
  if (component.state.debug) {
    headers.push("Repo Date");
    headers.push("Closing Date");
    colAlign.push("left");
    colAlign.push("left");
  }
  if (is_admin) {
    headers.push("Total");
    colAlign.push("right");
  }

  const balances = component.getUserDashboard().balances;
  const draw_down = component.get_draw_down();
  const deposits_usd = component.get_deposits();

  const data = [
    headers.map(label => {
      const ov = {
        fontSize: do_small ? "1rem" : "1.4rem",
      }
      return (<span>{ renderHeader(label, ov)}</span>);
    })
  ];

  const acct_index = 'acct_index' in component.props.args
    ? parseInt(component.props.args.acct_index, 10) : -1;

  let prefix = null;
  if (acct_type === USER) {
    prefix = "/user/";
  } else if (acct_type === SUPER_ADMIN) {
    prefix = "/super-admin/portfolio";
  } else if (acct_type === WLF_ADMIN) {
    prefix = "/wlf-admin/portfolio";
  }

  const renderDollar = value => {
    if (typeof value === "number") {
      return dollarToString(value);
    }
    return value;
  };

  const renderCashDrawdown = (cash, purchase_usd, deposits_usd) => {
    if (purchase_usd === 0. && deposits_usd === 0.) {
      return (<span>{renderDollar(cash)}</span>);
    }
    if (cash === "PENDING") {
      cash = 0.0;
    }
    let dep_div, purchase_div;
    const green_style = {
      color: "#3A3",
    }
    const red_style = {
      color: "#A33"
    }
    if (deposits_usd !== 0.) {
      dep_div = (
        <div style={green_style}>+ {renderDollar(deposits_usd)} in deposits</div>)
    }
    if (purchase_usd !== 0.) {
      purchase_div = (
        <div style={red_style}>- {renderDollar(purchase_usd)} in purchases</div>)
    }
    const avail = cash - purchase_usd + deposits_usd;
    return (<div>
      <div>{renderDollar(cash)} current</div>
      { dep_div }
      { purchase_div }
      <div>{renderDollar(avail)} in buying power</div>
    </div>);
  }

  balances.accts.forEach((acct, index) => {
    const url = prefix + objToUrlParam({
      username: component.props.username,
      // If acct_index is -1, then we are viewing all the accounts, and we should use the
      // iterated index. Else, we're viewing a single account, and we should use acct_index.
      acct_index: sprintf("%d", acct_index === -1 ? index : acct_index),
    })
    const acct_name = acct.name.split("-").pop();
    let acct_item = null;
    if (acct_type === USER) {
      acct_item = (<span>{acct_name}</span>);
    } else {
      acct_item = (<span><Link to={url}>{acct_name}</Link></span>)
    }
    const pct = acct.securities_change === 0.0
      ? 0.0 : acct.securities_change / acct.value;

    const line = [
      acct_item,
      (<span>{renderDollar(acct.value)}</span>),
      (<span>{renderDollar(acct.securities_value)}</span>),
      renderCashDrawdown(acct.cash, draw_down, deposits_usd),
      (<span>{renderPrice_2(acct.securities_change)}</span>),
      (<span>{renderPercent(pct)}</span>),
    ];
    if (component.state.debug) {
      // Push Repo date
      const repo_date = balances.repo_date
      let date, yy, mm, dd;
      if (repo_date) {
        [yy,mm,dd] = repo_date.split("-");
        date = sprintf("%s-%s-%s", mm, dd, yy);
      } else {
        date = "no repo date";
      }

      line.push((<span>{date}</span>));

      if (acct.closing_date) {
        // Push Closing date
        [yy, mm, dd] = acct.closing_date.split("-");
        const closing_date = sprintf("%s-%s-%s", mm, dd, yy);
        line.push((<span>{closing_date}</span>));
      } else {
        line.push((<span>No closing date</span>));
      }

    }
    if (is_admin) {
      line.push(
        (<span>{renderDollar(acct.value)}</span>)
      );
    }
    data.push(line);
  });

  const tableStyle = {
    width: "100%",
    overflow: "auto",
  }

  let new_data = [];

  if (do_small) {
    const num_row = data[0].length;
    // Transpose the data
    for (let row = 0; row < num_row; row++) {
      new_data.push([
        data[0][row], data[1][row]
      ]);
    }
  } else {
    new_data = data;
  }

  const tdStyle = {
    paddingTop: "0.5rem",
  }

  return (
    <DashboardTable
      title="Balances"
      tableStyle={tableStyle}
      underline_header={true}
      td_style={tdStyle}
      align={colAlign}
      data={new_data}/>
  );
};

const PotentialButton = props => {

  const component = props.component;

  const text_style = {
    paddingBottom: "0.3rem",
  }

  const container_style = {
    display: "flex",
    alignItems: "flex-end",
    border: "0.2px solid #555",
    paddingLeft: "0.5rem",
    paddingRight: "0.7rem",
    background: component.state.potential_bg && "#DDD",
    cursor: "pointer",
  }

  const enter_leave = enter => () => {
    component.setState({
      potential_bg: enter,
    })
  }

  const on_click = () => {
    component.setState({
      potential_bg: false,
    })
    component.onBannerClick("potential");
  }

  return (
    <div style={{ display: "flex", flex: "1", alignItems: "flex-end"}}>
      <div style={{ flex: "1" }}/>
      <div
        style={container_style}
        onClick={on_click}
        onMouseEnter={enter_leave(true)}
        onMouseLeave={enter_leave(false)}>
        <div>
          <img src={BARS_SVG} alt={"potential"}/>
        </div>
        <div style={text_style}>
          <span style={{fontWeight: "bold"}}>AI Portfolio Insights</span>
        </div>
      </div>
    </div>
  );
}

const Balances_ = props => {
  const component = props.component;
  const balances = component.getUserDashboard().balances;

  const pct = balances.total_change === 0.0
    ? 0.0 : balances.total_change / balances.total_value;

  const data = [
    [ renderHeader("Total Value"), renderHeader("Change") ],
    [ renderPrice(balances.total_value, "2rem"),
      (<span>
          {renderPrice(balances.total_change, "0.5rem")}
        { " " }
        {renderPercent(pct)}
        </span>)],
  ];

  if (component.state.debug) {
    data[0].push(renderHeader("Repo Date", { paddingLeft: "1rem"}));
    const repo_date = balances.repo_date;
    let date;
    if (repo_date) {
      const [yy,mm,dd] = repo_date.split("-");
      date = sprintf("%s-%s-%s", mm, dd, yy);
    } else {
      date = "no repo date";
    }

    const span_style = {
      fontSize: priceFontSize,
      paddingLeft: "1rem",
    }
    data[1].push((<span style={span_style}>{date}</span>));
  }

  const device = props.app.device;
  const do_small = device === DEVICE.tiny || device === DEVICE.small;
  const device_prop = {
    width: props.app.width,
  }
  // Only show the potential button if we're viewing a specific account.
  const do_bd = component.props.app.wlf.broker_dealer;
  const show_potential = component.props.acct_index !== "-1" && !do_bd;
  const potential = show_potential
    ? (<PotentialButton component={component}/>) : null;

  return (
    <DashboardContainer
      device={device_prop}
      client={props.client}
      header={potential}
      title={"Balances"}>
      { renderAccountTable(component, props.user, do_small) }
    </DashboardContainer>
  )
};

const mapStateToProps = state => {
  return {
    client: state.client,
    app: state.app,
    user: state.user,
    userPayments: state.userPayments,
  }
}

const Balances = connect(mapStateToProps)(Balances_);

export { Balances };
